import { useCallback } from 'react'
import { usePathname } from 'next/navigation'

import { getCurrentPage, getCustomerPages } from '~/app/helpers'
import { isRadiusUser } from '~/helpers/auth'

import { useAuthenticatedUser } from '~/hooks/useAuthentication'

import {
  MIXPANEL_CUSTOMER_PAGE_NAMES,
  MixpanelEvent,
  track,
} from '~/clients/mixpanelClient'

const useTrackCvtEvent = (): ((
  event: MixpanelEvent,
  properties?: Record<string, unknown>
) => void) => {
  const pathname = usePathname()
  const [user] = useAuthenticatedUser()

  return useCallback(
    (event, properties = {}) => {
      if (isRadiusUser(user)) {
        return
      }

      const page = getCurrentPage(
        pathname,
        getCustomerPages(user.role, user.customer?.type)
      )

      track(event, {
        page: page ? MIXPANEL_CUSTOMER_PAGE_NAMES[page.key] : undefined,
        ...properties,
      })
    },
    [pathname, user]
  )
}

export default useTrackCvtEvent
